import React from "react";
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton, Paper, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Create one array of 30 agents
const agents = Array.from({ length: 30 }, (_, i) => ({
  name: `Agent ${i + 1}`,
  code: `AG${String(i + 1).padStart(3, "0")}`,
  mobile: `98${Math.floor(10000000 + Math.random() * 90000000)}`,
}));

const agentsLeft = agents.slice(0, 15);
const agentsRight = agents.slice(15, 30);

const GroupAgentsViewModal = ({
  open,
  onClose,
  group,
}: {
  open: boolean;
  onClose: () => void;
  group: any;
}) => {
  console.log("Group Agents View Modal Opened for Group:", group);
  const theme = useTheme();
  const tableFont = theme.typography.body2.fontFamily;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: 500,
          maxWidth: 950,
          mx: 0,
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 6,
          p: 0,
        },
        component: Paper,
        elevation: 4,
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: tableFont,
          fontWeight: 800,
          fontSize: "1.25rem",
          pb: 1,
          px: 3,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={800}
          sx={{ fontFamily: tableFont, fontSize: "1.15rem" }}
        >
          Group Agents Details: {group?.name}
        </Typography>
        <IconButton onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Box sx={{ display: "flex", gap: 3 }}>
          {/* Left Table */}
          <Box sx={{ flex: 1 }}>
            <Box
              component="table"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: tableFont,
                fontSize: "0.97rem",
                bgcolor: "#f8f9fa",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
              }}
            >
              <thead>
                <tr style={{ background: "#f0f0f0" }}>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Name</th>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Code</th>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Mobile</th>
                </tr>
              </thead>
              <tbody>
                {agentsLeft.map((agent, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.name}
                    </td>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.code}
                    </td>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.mobile}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Box>
          </Box>
          {/* Right Table */}
          <Box sx={{ flex: 1 }}>
            <Box
              component="table"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: tableFont,
                fontSize: "0.97rem",
                bgcolor: "#f8f9fa",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
              }}
            >
              <thead>
                <tr style={{ background: "#f0f0f0" }}>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Name</th>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Code</th>
                  <th align="left" style={{ padding: "8px 12px", fontWeight: 700 }}>Mobile</th>
                </tr>
              </thead>
              <tbody>
                {agentsRight.map((agent, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.name}
                    </td>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.code}
                    </td>
                    <td
                      style={{
                        padding: "7px 12px",
                        fontFamily: theme.typography.body2.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        color: theme.palette.text.secondary,
                        fontWeight: theme.typography.body2.fontWeight,
                      }}
                    >
                      {agent.mobile}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GroupAgentsViewModal;